import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {authLoader} from '../../loader';
import {
  ROUTE_ADD_APPROVAL_CHAIN_DEFINITION_CONFIGURATION,
  ROUTE_APPROVAL_CHAIN_DEFINITION_CONFIGURATION,
  ROUTE_EDIT_APPROVAL_CHAIN_DEFINITION_CONFIGURATION,
} from '../../RoutePathConstant';

const ApprovalChainDefinition = lazy(() =>
  import('../../../screens/ApprovalChainDefinition')
    .then(module => ({default: module.ApprovalChainDefinition})));

const AddNewApprovalChainDefinition = lazy(() =>
  import('../../../screens/ApprovalChainDefinition')
    .then(module => ({default: module.AddNewApprovalChainDefinition})));

const EditApprovalChainDefinition = lazy(() =>
  import('../../../screens/ApprovalChainDefinition')
    .then(module => ({default: module.UpdateApprovalChainDefinition})));

const ApprovalChainDefinitionNavigation = [
  {
    path: ROUTE_APPROVAL_CHAIN_DEFINITION_CONFIGURATION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ApprovalChainDefinition />
      </Suspense>
    ),
  },
  {
    path: ROUTE_ADD_APPROVAL_CHAIN_DEFINITION_CONFIGURATION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <AddNewApprovalChainDefinition />
      </Suspense>
    ),
  },
  {
    path: ROUTE_EDIT_APPROVAL_CHAIN_DEFINITION_CONFIGURATION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <EditApprovalChainDefinition />
      </Suspense>
    ),
  },
];

export default ApprovalChainDefinitionNavigation;
